import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import { getFolioEnlaces } from 'actions/downloads.actions';
import PropTypes from 'prop-types';
import { ReactComponent as Link } from 'assets/images/Enlaces/white_link.svg';
import EnlacesModal from 'components/InfoModal/Enlaces/EnlacesModal';
import Button from '../Button/Button';
import './BotonGeneracionEnlaces.scss';

export const BotonGeneracionEnlaces = (props) => {
  // const [downloadType, setDownloadType] = useState(DOWNLOAD_TYPES.TESTIGOS.value);
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [idEnlaces, setIdEnlaces] = useState('');
  const dispatch = useDispatch();

  const { tipoMonitoreo, tipoActa, descripcion, cerrarDescripcion } = props;
  const datosUser = useSelector((state) => state?.validarUsuario?.data);

  const getMonitoreosSeleccionados = () => {
    const monitoreos = [];
    const { seleccion } = props;
    let validacion = false;
    Object.entries(seleccion.current).forEach(([key, value]) => {
      if (typeof key === 'string' && !key.includes('D-') && value) {
        validacion = true;
        monitoreos.push(key);
      }
    });
    if (!validacion) {
      return null;
    }
    return monitoreos;
  };

  const handleOnCloseModal = () => {
    // console.log('entro aqui a handleclose');
    const { onClearSeleccion } = props;
    onClearSeleccion?.();
    cerrarDescripcion?.();
    setIsVisibleSuccessModal(false);
  };

  const handleAddColaEnlaces = async () => {
    // const { tipoMonitoreo, tipoActa } = props;
    const listaIds = getMonitoreosSeleccionados();
    if (listaIds !== null) {
      setIsLoading(true);
      if (descripcion !== null && descripcion !== undefined && descripcion?.length > 0) {
        const { success, response } = await dispatch(
          getFolioEnlaces({
            tipoDescarga: 3,
            tipoMonitoreo,
            tipoActa,
            listaIdMonitoreos: listaIds,
            generarEnlances: 1,
            descripcionEnlaces: descripcion
          })
        );
        if (success) {
          setIsLoading(false);
          setIdEnlaces(response?.data?.folio_enlaces);
          setIsVisibleSuccessModal(true);
        }
      }
    } else {
      message.error('Debes seleccionar al menos un monitoreo.');
    }
  };

  return (
    <div className="selector-tipo-descarga">
      <EnlacesModal
        visible={isVisibleSuccesModal}
        onClose={handleOnCloseModal}
        idEnlace={idEnlaces}
      />
      <div className="download-type-container">
        {datosUser.rol.includes('ADMIN') || datosUser.rol.includes('VALIDADOR') ? (
          <Button
            text="Generar enlace"
            type="primary"
            onClick={handleAddColaEnlaces}
            isLoading={isLoading}
            icon={<Link />}
            style={{ display: 'flex', alignItems: 'center' }}
          />
        ) : null}
      </div>
    </div>
  );
};

BotonGeneracionEnlaces.propTypes = {
  seleccion: PropTypes.shape({ current: PropTypes.shape({ forEach: PropTypes.func }) }).isRequired,
  tipoMonitoreo: PropTypes.number.isRequired,
  tipoActa: PropTypes.number.isRequired,
  descripcion: PropTypes.string.isRequired,
  onClearSeleccion: PropTypes.func,
  cerrarDescripcion: PropTypes.func.isRequired
};

BotonGeneracionEnlaces.defaultProps = {
  onClearSeleccion: () => {
    // handleClose function here
  }
};

export default BotonGeneracionEnlaces;
